<template>
    <div
        class="campaign-item-container"
        :class="{ 'is-notification': isNotification, 'is-hotspot': isHotspot }">

        <div
            @click="toggleFavorite"
            style="position: absolute; right: 0; width: 48px; height: 48px; z-index: 90; display: flex; align-items: center; justify-content: center;">
            <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px;" :fill="hasFavoritedCampaign ? '#E05054' : '#F2FAFD'" viewBox="0 0 24 24" stroke="currentColor">
                <path :stroke="hasFavoritedCampaign ? '#E05054' : '#F2FAFD'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
        </div>

        <div @click="handleClickEvent" class="campaign-item campaign-item-slider" style="position: relative;">
            <div
                v-if="campaign.main_image_path"
                style="background-repeat: no-repeat; background-attachment: center; background-position: center; background-size: cover;"
                v-lazy="{
                    src: campaign.main_image_path,
                    loading: campaign.main_image_path,
                    error: fallback,
                }"
                class="campaign-item-cover">
            </div>

            <div
                v-if="!campaign.main_image_path"
                :style="{
                    background: 'url(' + fallback + ') no-repeat center center',
                    backgroundSize: 'cover'
                }"
                class="campaign-item-cover">
            </div>

            <div class="campaign-item-logo">
                <img
                    v-if="campaign.company_logo_image_path"
                    v-lazy="{
                        src: campaign.company_logo_image_path
                    }"
                    :alt="campaign.company_name"
                    :title="campaign.company_name">
            </div>

            <div class="campaign-item-heading" style="margin-top: 5px;">
                <p class="card-text" style="line-height: 24px;" v-if="campaign.heading">{{ title || campaign.heading  }} </p>
            </div>

            <div v-if="isNotification" class="text-center" style="font-family: AvertaLight;">
                {{ message }}
            </div>

            <div class="campaign-item-action" v-if="!isNotification">
                <inertia-link
                    v-if="!isHotspot"
                    :href="`/${campaign.company_slug}/${campaign.campaign_public_id}-${campaign.slug}`"
                    class="btn btn-outline-dark"> {{ $t('to_the_deal') }} </inertia-link>
                <inertia-link
                    v-else
                    :href="`/${campaign.company_slug}/${campaign.campaign_public_id}-${campaign.slug}`"
                    class="btn btn-outline-dark"> Pangrabatt! </inertia-link>
            </div>

            <slot v-if="isNotification"></slot>
        </div>
    </div>
</template>

<script>
    import { router } from '@inertiajs/vue3';
    import { getFallbackImage } from '@/Util/images';
    import { toggleCampaignAsFavorite, hasFavoritedCampaign } from '@/services/favorites';
    export default {
        props: {
            campaign: { type: Object, required: true },
            isNotification: { type: Boolean, default: false },
            title: { type: String },
            message: { type: String },
            tempUserFavos: {
                companies: [],
                campaigns: [],
            },
            banner: {
                type: Object,
                default: function () {
                    return { type: null, text: null };
                },
            },
        },
        data () {
            return {
                hasFavoritedCampaign: false,
            }
        },
        mounted () {
            this.hasFavoritedCampaign = hasFavoritedCampaign(this.campaign.slug);
        },
        computed: {
            isHotspot() {
                return (this.banner && this.banner.type);
            },
            fallback() {
                return getFallbackImage();
            }
        },
        methods: {
            async toggleFavorite() {
                this.hasFavoritedCampaign = !this.hasFavoritedCampaign;

                await toggleCampaignAsFavorite(this.campaign.slug);

                if (this.hasFavoritedCampaign) {
                    this.$moshaToast('Kampanjen har lagts till i dina favoriter!', {
                        type: 'success',
                        timeout: 2000,
                    });
                }
            },

            handleClickEvent () {
                if (!this.isNotification) {
                    router.visit(`/${this.campaign.company_slug}/${this.campaign.campaign_public_id}-${this.campaign.slug}`);
                }
            }
        }
    }
</script>
